import { jsx as r } from "react/jsx-runtime";
import { createContext as s, useContext as i } from "react";
const t = s(void 0), u = (e) => /* @__PURE__ */ r(t.Provider, { value: { sites: e.sites }, children: e.children }), c = () => {
  const e = i(t);
  if (!e)
    throw new Error("useSites must be used within a SitesProvider");
  return e.sites;
};
export {
  u as SitesProvider,
  c as useSites
};
